import {
  _ReleasesListLinks,
  CreateReleaseValidations,
  ExportReleaseValidations,
  Release,
  ReleaseVersion,
  UpdateReleaseSongTitleValidations,
  UpdateReleaseValidations,
  UpdateVersionSongValidations,
  UpdateReleaseVersionValidations,
  SoundCloudRelease,
  SoundCloudVersion,
  UpdateSCVersionAudioValidations,
  PlaylistTypesListItem,
} from 'types/releases';
import { DDL } from 'types/general.types';
import { GenericObject } from 'types/generic.types';

export interface ReleasesState {
  release?: Release;
  releases: Release[];
  releaseVersion?: ReleaseVersion;
  updateVersionSongValidations?: UpdateVersionSongValidations;
  updateReleaseVersionValidations?: UpdateReleaseVersionValidations;
  updateSCVersionAudioValidations?: UpdateSCVersionAudioValidations;
  updateReleaseSongTitleValidations?: UpdateReleaseSongTitleValidations;
  exportReleaseValidations?: ExportReleaseValidations;
  updateReleaseValidations?: UpdateReleaseValidations;
  _releasesListLinks?: _ReleasesListLinks;
  releaseVersionTypes?: DDL;
  createReleaseValidations?: CreateReleaseValidations;
  currentlyReplacingAudio: GenericObject<boolean>;
  syncStatus: GenericObject<boolean>;
  playlistTypesList: PlaylistTypesListItem[];
  tuneCoreSuccessDialog?: { guid: string };
  tuneCoreFailureDialog?: { guid: string };
  releaseVersionsDetails?: { lyrics: { isExcluded: boolean } }[];
  export?: {
    releaseGuid: string;
    isAudioUploadSupported?: boolean;
  };
}

export const syncSoundCloudVersionList = (
  state: ReleasesState,
  updatedData: Partial<SoundCloudVersion>,
  versionGuid?: string
) => {
  const release = state.release as SoundCloudRelease;
  if (release?.versions) {
    const versionIndex = release.versions.findIndex(
      (version) =>
        version.guid ===
        (versionGuid || (state.releaseVersion as ReleaseVersion)?.metadata.guid)
    );
    if (versionIndex >= 0) {
      release.versions[versionIndex] = {
        ...release.versions[versionIndex],
        ...updatedData,
      };
    }
  }
};
